import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * useTierUpWatcher — calls /api/reputation/me on mount and at a long interval.
 * Returns {tierUp, dismiss}. tierUp is non-null only when the server detects an
 * upward tier transition since the last call (server persists last_seen_tier).
 */
export default function useTierUpWatcher() {
  const { user } = useAuth();
  const [tierUp, setTierUp] = useState(null);

  useEffect(() => {
    if (!user) return undefined;
    let alive = true;
    let timer;

    const check = async () => {
      try {
        const { data } = await api.get("/reputation/me");
        if (alive && data?.tier_up) {
          setTierUp(data.tier_up);
        }
      } catch {
        /* ignore */
      }
    };

    // First check after a small delay so the login flow finishes
    timer = setTimeout(check, 1500);
    const interval = setInterval(check, 120000); // every 2 min
    return () => {
      alive = false;
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, [user]);

  const dismiss = async () => {
    setTierUp(null);
    try { await api.post("/reputation/dismiss-tier-up"); } catch { /* ignore */ }
  };

  return { tierUp, dismiss };
}
